function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "logo_googleg_48dp"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5 12.7844C24.5 11.898 24.4205 11.0457 24.2727 10.2275H12.5V15.0628H19.2273C18.9375 16.6253 18.0568 17.9491 16.733 18.8355V21.9719H20.7727C23.1364 19.7957 24.5 16.5912 24.5 12.7844Z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4986 25C15.8736 25 18.7031 23.8807 20.7713 21.9716L16.7315 18.8352C15.6122 19.5852 14.1804 20.0284 12.4986 20.0284C9.2429 20.0284 6.48722 17.8295 5.50426 14.875H1.32812V18.1136C3.38494 22.1989 7.61222 25 12.4986 25Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.50568 14.8746C5.25568 14.1246 5.11364 13.3234 5.11364 12.4996C5.11364 11.6757 5.25568 10.8746 5.50568 10.1246V6.88593H1.32955C0.482955 8.57343 0 10.4825 0 12.4996C0 14.5166 0.482955 16.4257 1.32955 18.1132L5.50568 14.8746Z",
  fill: "#FBBC05"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_4",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4986 4.97159C14.3338 4.97159 15.9815 5.60227 17.277 6.84091L20.8622 3.25568C18.6974 1.23864 15.8679 0 12.4986 0C7.61222 0 3.38494 2.80114 1.32812 6.88636L5.50426 10.125C6.48722 7.17045 9.2429 4.97159 12.4986 4.97159Z",
  fill: "#EA4335"
}));

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e96cc593aaa410d3beb38770dbc9cd38.svg";
export { ForwardRef as ReactComponent };